<template>
  <div>
    <apexchart ref="status-chart" :options="options" :series="series" class="donut-chart" type="donut" width="100%"></apexchart>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      options: {
        chart: {
          width: "700px",
          height: "400px",
        },
        labels: ["Concretizadas", "Canceladas"],
        colors: ["#0095ff", "#ff0000"],
        dataLabels: {
          style: {
            colors: ["#000000"],
          },
          dropShadow: {
            enabled: false,
          },
        },
        legend: {
          fontSize: "20px",
        },
        responsive: [
          {
            breakpoint: 2561,
            options: {
              chart: {
                width: "80%",
              },
              legend: {
                position: "right",
              },
            },
          },
          {
            breakpoint: 1921,
            options: {
              chart: {
                width: "100%",
              },
              legend: {
                position: "right",
              },
            },
          },
          {
            breakpoint: 1900,
            options: {
              chart: {
                width: "80%",
              },
              legend: {
                fontSize: "20px",
                position: "bottom",
              },
            },
          },
          {
            breakpoint: 1441,
            options: {
              chart: {
                width: "80%",
                height: "315px",
              },
              legend: {
                fontSize: "15px",
                position: "bottom",
              },
            },
          },
          {
            breakpoint: 1025,
            options: {
              chart: {
                height: "250px",
              },
            },
          },
          {
            breakpoint: 976,
            options: {
              chart: {
                width: "100%",
                height: "180px",
              },
              legend: {
                fontSize: "10px",
              },
            },
          },
        ],
      },
    };
  },
  props: ["series"],
};
</script>
